import Layout from "../components/Layout";
import Customers  from "../components/_Customers";

const CustomersPage = (props: any) => {
    return (
        <Layout>
            <Customers />
        </Layout>
    )
}

export default CustomersPage